<template>
  <div>
    <div v-if="operasiBiaya">
      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">Detail Biaya</h4>
        <router-link
          :to="
            `/operasi/form-biaya/${$route.params.id_ralan}/${$route.params.id}?fromTab=3`
          "
          class="btn btn-with-icon-left btn-primary text-uppercase"
        >
          <i class="material-symbols-outlined">create</i>
          Ubah Detail Biaya
        </router-link>
      </div>
      <div class="row mb-5">
        <div class="col-md-8">
          <b-card>
            <b-card-body>
              <FormRowInline
                v-for="row in costForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
                @handleBlur="(e) => handleBlur(e)"
              />
              <div class="row mt-4">
                <div class="col-md-6">
                  <h4>Total Tagihan</h4>
                </div>
                <div class="col-md-6">
                  <h4 class="text-primary text-right">
                    {{ convertToRupiah(total_tagihan) }}
                  </h4>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
    <EmptyState v-else :data="empty" />
  </div>
</template>

<script>
import FormRowInline from "@/components/FormRowInline.vue";
import { convertToRupiah } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { dataOperasi, costConstant } from "@/data/OperasiForm.js";
import { costForm } from "@/data/OperasiDetail.js";
import EmptyState from "@/components/EmptyState.vue";
export default {
  props: { ralan: Object, operasi: Object },
  name: "OperasiFormLaporan",
  components: {
    EmptyState,
    FormRowInline,
  },
  data: () => {
    return {
      empty: {
        img: "/img/nurse.svg",
        title: "Belum ada biaya operasi",
        content:
          "Isi data detail biaya operasi dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/operasi/form-biaya/",
        label: "input biaya operasi",
      },
      data: dataOperasi,
      detailTop: null,
      costForm: costForm,
      operasiBiaya: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      id_biaya: null,
      total_tagihan: 0,
      formSet: {
        id: null,
        id_operasi: null,
        jenis_paket_operasi: 0,
        jasa_dokter_operator: 0,
        jasa_dokter_anestesi: 0,
        // "jasa_dokter_referal": 0,
        jasa_perawat_anestesi: 0,
        jasa_instrumentator: 0,
        jasa_perawat_sirkuler: 0,
        sewa_kamar_operasi: 0,
        pemberian_obat_dan_alat_kesehatan: 0,
        biaya_lain_lain: 0,
      },
      saveSuccess: false,
      saveFailed: false,
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    save: async function() {
      this.handleForm(function() {
        location.reload();
      });
    },
    continue: function() {
      this.$router.push(
        `/operasi/detail/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function(callback) {
      this.errors = [];
      let formData = new FormData();
      let body = "";
      var self = this;
      ////console.log(this.formSet);
      let valid = this.validateForm();
      if (valid) {
        formData.append("total_tagihan", this.total_tagihan);
        body += `total_tagihan=${this.total_tagihan}`;
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, parseInt(self.formSet[key]));
          body += `&${key}=${parseInt(self.formSet[key])}`;
        });
        try {
          let result;
          ////console.log('Id Biaya: '+this.id_biaya);
          if (this.id_biaya) {
            result = await this.$store.state.HTTP_ENC.put(
              "operasi_biaya/" + this.id_biaya,
              body
            );
          } else {
            result = await this.$store.state.HTTP.post(
              "operasi_biaya",
              formData
            );
          }
          ////console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
              if (callback) {
                callback();
              }
            }, 1000);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = parseInt(e.target.value);
      }
      ////console.log(this.formSet[e.target.name]);
      // this.updateTotalTagihan();
    },
    updateTotalTagihan() {
      // this.total_tagihan=this.formSet.jenis_paket_operasi+this.formSet.jasa_dokter_referal+this.formSet.jasa_perawat_anestesi+this.formSet.jasa_instrumentator+this.formSet.jasa_perawat_sirkuler+this.formSet.sewa_kamar_operasi+this.formSet.pemberian_obat_dan_alat_kesehatan+this.formSet.biaya_lain_lain;

      // Hapus jasa dokter referal
      this.total_tagihan =
        this.formSet.jenis_paket_operasi +
        this.formSet.jasa_perawat_anestesi +
        this.formSet.jasa_instrumentator +
        this.formSet.jasa_perawat_sirkuler +
        this.formSet.sewa_kamar_operasi +
        this.formSet.pemberian_obat_dan_alat_kesehatan +
        this.formSet.biaya_lain_lain;
      this.updateForm();
    },
    handleBlur(e) {
      ////console.log(e);
      // this.total_tagihan=this.formSet.jenis_paket_operasi+this.formSet.jasa_dokter_referal+this.formSet.jasa_perawat_anestesi+this.formSet.jasa_instrumentator+this.formSet.jasa_perawat_sirkuler+this.formSet.sewa_kamar_operasi+this.formSet.pemberian_obat_dan_alat_kesehatan+this.formSet.biaya_lain_lain;

      // Hapus jasa dokter referal

      this.total_tagihan =
        this.formSet.jenis_paket_operasi +
        this.formSet.jasa_perawat_anestesi +
        this.formSet.jasa_instrumentator +
        this.formSet.jasa_perawat_sirkuler +
        this.formSet.sewa_kamar_operasi +
        this.formSet.pemberian_obat_dan_alat_kesehatan +
        this.formSet.biaya_lain_lain;
      this.updateForm();
    },
    fetchLaporan: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_laporan?id_operasi=${this.$route.params.id}`
      );
      ////console.log('data laporan');
      ////console.log(result);
      ////console.log(result.data);
      ////console.log(result.data.data);
      ////console.log('data laporan');

      if (result.data.data.length) {
        let nSirkuler = 0;
        this.id_laporan = result.data.data[0].id;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_biaya/${this.id_laporan}`
        );
        ////console.log(result2);
        this.operasiLaporan = result2.data;
        // if(this.operasiLaporan.operasi_laporan_perawat_sirkuler && this.operasiLaporan.operasi_laporan_perawat_sirkuler.length){
        //   nSirkuler = this.operasiLaporan.operasi_laporan_perawat_sirkuler.length;
        // }
        nSirkuler =
          (this.operasiLaporan.id_perawat_sirkuler_1 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_2 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_3 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_4 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_5 ? 1 : 0);
        this.formSet.jasa_perawat_sirkuler = nSirkuler * costConstant.sirkuler;
        ////console.log(this.operasiLaporan.operasi_laporan_perawat_sirkuler);
        this.costForm[6].columns[0].label = `Jasa Perawat Sirkuler (${nSirkuler} orang)`;
        this.costForm[6].columns[0].additional = `${nSirkuler} x ${costConstant.sirkuler_formatted}`;
        // this.updateForm();
        this.updateTotalTagihan();
      }
    },
    fetchTindakan: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_tindakan?id_operasi=${this.$route.params.id}`
        );
        ////console.log(result);
        let self = this;
        if (result.status == "200") {
          this.formSet["jenis_paket_operasi"] = 0;
          result.data.data.forEach((item) => {
            self.formSet["jenis_paket_operasi"] += item.biaya;
          });
          this.updateTotalTagihan();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchObat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_obat?id_operasi=${this.$route.params.id}`
        );
        let self = this;
        ////console.log(result);
        if (result.status == "200") {
          this.formSet["pemberian_obat_dan_alat_kesehatan"] = 0;
          result.data.data.forEach((item) => {
            self.formSet["pemberian_obat_dan_alat_kesehatan"] += item.sub_total;
          });
          this.updateTotalTagihan();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      this.costForm = this.costForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          if (self.formSet[column.name]) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      ////console.log(this.costForm);
      return valid;
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_biaya?id_operasi=${this.$route.params.id}`
      );
      ////console.log(result);
      ////console.log(result.data);
      ////console.log(result.data.data);
      if (result.data.data.length) {
        this.id_biaya = result.data.data[0].id;
        let self = this;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_biaya/${this.id_biaya}`
        );
        ////console.log(result2);
        this.operasiBiaya = result2.data;
        Object.keys(this.formSet).forEach(function(key) {
          self.formSet[key] = self.operasiBiaya[key];
        });
        // this.updateForm();
        this.updateTotalTagihan();
      } else {
        // this.formSet['jasa_dokter_referal']=costConstant.operator;
        this.formSet["jasa_perawat_anestesi"] = costConstant.anestesi;
        this.formSet["jasa_instrumentator"] = costConstant.instrumentator;
        this.formSet["sewa_kamar_operasi"] = costConstant.kamar;
        this.formSet["biaya_lain_lain"] = costConstant.lain;
        this.updateForm();
        //this.updateTotalTagihan();
        // this.formSet['pemberian_obat_dan_alat_kesehatan']
        // this.formSet['jenis_paket_operasi']
        // this.formSet['jasa_perawat_sirkuler']=costConstant.sirkuler*1;
        await this.fetchLaporan();
        await this.fetchTindakan();
        await this.fetchObat();
      }
    },
    updateForm() {
      let self = this;
      this.costForm = this.costForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (self.formSet[column.name] || self.formSet[column.name] == 0) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      ////console.log(this.costForm);
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.empty.link +=
      this.$route.params.id_ralan + "/" + this.$route.params.id + "?fromTab=3";
    this.formSet["id_operasi"] = this.$route.params.id;
    await this.fetchData();
  },
};
</script>
